import React, { Component } from 'react';
import MailchimpSubscribe from "react-mailchimp-subscribe"
import {env} from "./../../configs/EnviromentsConfigs"
const url = env.URL_NEWSLETTER;

const CustomForm = ({ status, message, onValidated }) => {
    let email, name;
    const submit = () =>
        email &&
       // name &&
        email.value.indexOf("@") > -1 &&
        onValidated({
            EMAIL: email.value,
            //NAME: name.value
        });

    return (
        <div>
            <div>
                {status === "sending" && <div style={{ color: "blue" }}>attendere...</div>}


                {/*<input
                    ref={node => (name = node)}
                    type="text"
                    placeholder="Inserisci il tuo nome"
                />*/}

                <input ref={node => (email = node)}
                       type="email"
                       placeholder="Inserisci la tua mail"
                />

                <button onClick={submit}>
                    Iscriviti
                </button>
            </div>
            <div>
                {status === "error" && (
                    <div
                        style={{ color: "red" }}
                        dangerouslySetInnerHTML={{ __html: message }}
                    />
                )}
                {status === "success" && (
                    <div style={{ color: "green" }}> Grazie per esserti iscritto </div>
                )}
            </div>
        </div>
    );
};
class NewsLetter extends Component {
    render() {
        return (
                    <div className="footer-subscibe-area pt-120 pb-120">
                        <div className="container">
                            <div style={{marginRight: "0px",marginLeft: "0px"}} className="row justify-content-center">
                                <div className="col-lg-8">
                                    <div className="subscribe-text text-center">
                                        <div className="footer-logo mb-45">
                                            <img style={{width: "40%"}} src={process.env.PUBLIC_URL + "/assets/img/logo/scontorno/logo_blu.svg"} alt="logo" />
                                        </div>
                                        <p>
                                            Iscrivi alla nostra newsletter
                                        </p>
                                        <div className="subscribe-form mt-50" >
                                            {/*<input type="email" placeholder="Inserisci la tua mail" />
                                            <button type="submit">iscriviti</button>*/}


                                            <MailchimpSubscribe
                                                url={url}
                                                render={({ subscribe, status, message }) => (
                                                    <CustomForm
                                                        status={status}
                                                        message={message}
                                                        onValidated={formData => subscribe(formData)}
                                                    />

                                                )}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
        );
    }
}

export default NewsLetter;